import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { DOCUMENTATION_TYPES } from '../../../constants';
import {
  selectUserDocumentsList,
  selectUserDocumentsLoading,
} from '../../../redux/profiles/selectors';
import {
  getInsuranceCardDocumentsConfig,
  getDriverLicenseDocumentConfig,
} from '../../../utils/getDocumentsConfig';

const DRIVER_LICENSE_CARD_KEYS = [DOCUMENTATION_TYPES.DRIVER_LICENCE];

const INSURANCE_CARD_KEYS = [
  DOCUMENTATION_TYPES.CARD_1,
  DOCUMENTATION_TYPES.CARD_2,
];

const useUserDocuments = ({ isEditMode = true }) => {
  const { formatMessage } = useIntl();

  const documents = useSelector(selectUserDocumentsList);

  const isDocumentsFetching = useSelector(selectUserDocumentsLoading);

  const { insuranceDocuments, driverLicenseDocuments } = useMemo(() => {
    return documents.reduce(
      (acc, doc) => {
        const { key } = doc || {};

        if (INSURANCE_CARD_KEYS.includes(key)) {
          acc.insuranceDocuments.push(doc);
        }

        if (DRIVER_LICENSE_CARD_KEYS.includes(key)) {
          acc.driverLicenseDocuments.push(doc);
        }

        return acc;
      },
      { insuranceDocuments: [], driverLicenseDocuments: [] },
    );
  }, [documents]);

  const configParams = useMemo(
    () => ({
      isEditMode,
      userDocuments: documents,
      formatMessage,
    }),
    [documents, formatMessage, isEditMode],
  );

  const insuranceDocumentsConfig = useMemo(
    () => getInsuranceCardDocumentsConfig(configParams),
    [configParams],
  );

  const driverLicenseDocumentsConfig = useMemo(
    () => getDriverLicenseDocumentConfig(configParams),
    [configParams],
  );

  return {
    documents,
    driverLicenseDocuments,
    driverLicenseDocumentsConfig,
    insuranceDocuments,
    insuranceDocumentsConfig,
    isDocumentsFetching,
  };
};

export default useUserDocuments;



// WEBPACK FOOTER //
// ./src/components/Paperwork/hooks/useUserDocuments.js